'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)();

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _actionTypes.ADD_AVAILABILITY_MESSAGE_TIMEOUT, function (state, action) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      timeout = _action$payload.timeout;


  return state.set(channel, timeout);
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/availability/reducers/availabilityMessageTimeouts.js
// module id = 863
// module chunks = 2 3